export default __webpack_public_path__ + "static/chillm-cd9813517eb97ec0dc0696c21d339c28.mp4";